import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, ProjectReportTemplate } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  reportTemplates: Identifiable<ProjectReportTemplate>[];
  retrieveProjectReportTemplate(
    request: Boundaries["retrieveProjectReportTemplate"]["request"],
  ): void;
}

function useRetrieveProjectReportTemplate(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectReportTemplateRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectReportTemplateRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectReportTemplateRequestFailure(planzone),
    ),
    reportTemplates: useSelector(() =>
      selector.getProjectReportTemplates(planzone),
    ),
    retrieveProjectReportTemplate: core.retrieveProjectReportTemplate,
  };
}

export { useRetrieveProjectReportTemplate };
